<mat-form-field appearance="outline" class="full-width">
  <mat-label>Search Tariff Codes & Consumables</mat-label>
  <input matInput #inputElement [formControl]="searchControl" [matAutocomplete]="auto" [disabled]="disabled"
    [placeholder]="placeholder" [required]="required" (focus)="focused = true" (blur)="focused = false; onTouched()"
    placeholder="Enter procedure code, medication name, or NAPPI code">
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)">
    <mat-option *ngFor="let item of filteredResults | async" [value]="item">
      <div class="option-container">
        <div class="option-main">
          <span class="option-code" *ngIf="item.type === 'procedure'">{{item.code}}</span>
          <span class="option-code" *ngIf="item.type === 'medication'">NAPPI: {{item.nappiCode}}</span>
          <span class="option-code" *ngIf="item.type === 'material'">Cat: {{item.catalogueNumber}}</span>
          <span class="option-description">{{getDisplayText(item)}}</span>
        </div>
        <div class="option-details" *ngIf="getSubText(item)">
          <small>{{getSubText(item)}}</small>
        </div>
        <div class="option-price" *ngIf="item.type === 'medication' || item.type === 'material'">
          <small>Price: R{{item.singleExitPrice | number:'1.2-2'}}</small>
        </div>
      </div>
    </mat-option>
    <mat-option *ngIf="(filteredResults | async)?.length === 0 && searchControl.value && searchCompleted">
      Can't find what you're looking for? <a (click)="openContactUsDialog($event)">Contact Us.</a>
    </mat-option>
  </mat-autocomplete>
  <mat-hint *ngIf="hintText">{{ hintText }}</mat-hint>
</mat-form-field>

<ng-template #codeTimeDialog>
  <h1 mat-dialog-title>Start/Finish Time Details</h1>
  <div mat-dialog-content>
    <div class="p-t-20">
      <mat-form-field appearance="outline" class="m-r-10">
        <mat-label>Start Time</mat-label>
        <input matInput [(ngModel)]="codeAdditionalInfo.startTime" [ngxTimepicker]="startTimePicker" [format]="24"
          required>
        <ngx-material-timepicker #startTimePicker [theme]="darkTheme" [appendToInput]="true"
          [preventOverlayClick]="true"></ngx-material-timepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="m-r-10">
        <mat-label>End Time</mat-label>
        <input matInput [(ngModel)]="codeAdditionalInfo.endTime" [ngxTimepicker]="endTimePicker" [format]="24" required>
        <ngx-material-timepicker #endTimePicker [theme]="darkTheme" [appendToInput]="true"
          [preventOverlayClick]="true"></ngx-material-timepicker>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="codeAdditionalInfo"
      [disabled]="!codeAdditionalInfo.startTime || !codeAdditionalInfo.endTime">Save</button>
  </div>
</ng-template>


<ng-template #codeAssistantDialog>
  <h1 mat-dialog-title>Surgical Assistant Details</h1>
  <div mat-dialog-content>
    <div class="p-t-20">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Assistant Name</mat-label>
        <input matInput [(ngModel)]="assistantAdditionalInfo.assistantName"
          (ngModelChange)="filterAssistants($event)" [matAutocomplete]="assistantAuto">
        <mat-autocomplete #assistantAuto="matAutocomplete" (optionSelected)="onAssistantSelected($event.option.value)">
          <mat-option *ngFor="let assistant of filteredAssistants" [value]="assistant.name">
            {{ assistant.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Practice Number</mat-label>
        <input matInput [(ngModel)]="assistantAdditionalInfo.assistantPracticeNumber">
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="assistantAdditionalInfo">Save</button>
  </div>
</ng-template>


<ng-template #codeBMIDialog>
  <h1 mat-dialog-title>BMI Details</h1>
  <div mat-dialog-content>
    <div class="p-t-20">
      <mat-form-field appearance="outline" class="m-r-10">
        <mat-label>Weight</mat-label>
        <input matInput [(ngModel)]="codeAdditionalInfo.weight" (input)="calculateBMI()" required>
        <span matSuffix>&nbsp; kg&nbsp;</span>
      </mat-form-field>
      <mat-form-field appearance="outline" class="m-r-10">
        <mat-label>Height</mat-label>
        <input matInput [(ngModel)]="codeAdditionalInfo.height" (input)="calculateBMI()" required>
        <span matSuffix>&nbsp; cm&nbsp;</span>
      </mat-form-field>
    </div>
    <p *ngIf="codeAdditionalInfo.BMI">Calculated BMI: {{codeAdditionalInfo.BMI}}</p>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" [mat-dialog-close]="codeAdditionalInfo">Save</button>
  </div>
</ng-template>